/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React, { Component } from "react";
import "react-responsive-modal/styles.css";
import Modal from "react-responsive-modal";
// Infterface for component Props
interface WhyAskingPopupProps {
  open: boolean;
  close: () => void;
  list: any;
  t?: any;
  questionType?: string;
}

// Infterface for component State
interface WhyAskingPopupState { }

/**
 * Why are we asking this popup component.
 *
 * @namespace WhyAskingPopup
 */

class WhyAskingPopup extends Component<
  WhyAskingPopupProps,
  WhyAskingPopupState
> {
  constructor(props: WhyAskingPopupProps) {
    super(props);
  }
  handleOnKeyPress = (event: any) => {
    if (event.key === "Enter" || event.key === " ") {
      this.props.close()
    }
  }
  render() {
    const { open, list, questionType } = this.props;
    return (
      <div>
        <Modal
          open={open}
          onClose={this.props.close}
          center
          classNames={{
            overlay: "custom-overlay",
            modal: "modal-container why-asking-modal",
            closeButton: "hide",
          }}
        >
          <div className="popup-wrapper">
            <div className="popup-header-container">
              <div tabIndex={0} role="button" className="popup-close-icon" onClick={this.props.close} onKeyPress={this.handleOnKeyPress}>
                <span className="icon close-icon"></span>
              </div>
              <div className="popup-header">
                <div className="popup-label">
                  {this.props.t("common.why_are_we_asking_this")}
                </div>
                {/* <span className="icon close-icon"></span> */}
              </div>
            </div>
            <div className="popup-inner-wrapper">
              {/* For question type is dropdown */}
              {questionType && questionType === "dropdown" ? (
                <div className="list-container">
                  <ul>
                    {list &&
                      list.map((item: any, itemIndex: any) => (
                        <li className="item" key={itemIndex}>
                          <div className="title">{item && item.title}</div>
                          {item && item.description}
                        </li>
                      ))}
                  </ul>
                </div>
              ) : (
                <div className="list-container">
                  <ul>
                    {list && list.length > 0
                      ? list.map((item: any, itemIndexer: any) => (
                        <li className="item" key={itemIndexer}>{item}</li>
                      ))
                      : null}
                  </ul>
                </div>
              )}
            </div>
            <div className="popup-bottom-section">
              <div tabIndex={0} role="button" className="label" onClick={this.props.close} onKeyPress={this.handleOnKeyPress}>
                {this.props.t("common.close")}
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WhyAskingPopup;
